module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"make a maze","short_name":"maze","start_url":"/","background_color":"#440bd4","theme_color":"#440bd4","display":"minimal-ui","icon":"content/assets/icon.png"},
    }]
